import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["checkboxField", "button"]
  }

  toggle() {
    if (this.checkboxFieldTarget.checked) {
      this.buttonTarget.removeAttribute("disabled")
    } else {
      this.buttonTarget.setAttribute("disabled", "true")
    }
  }
}
